var map = {
	"./Features-Block-Reviews-DA-DK-D.avif": 78762,
	"./Features-Block-Reviews-DE-DE-D.avif": 53404,
	"./Features-Block-Reviews-EN-GB-D.avif": 26650,
	"./Features-Block-Reviews-EN-US-D.avif": 36023,
	"./Features-Block-Reviews-ES-ES-D.avif": 77054,
	"./Features-Block-Reviews-ES-MX-D.avif": 98447,
	"./Features-Block-Reviews-FR-FR-D.avif": 72362,
	"./Features-Block-Reviews-IT-IT-D.avif": 20252,
	"./Features-Block-Reviews-NB-NO-D.avif": 28925,
	"./Features-Block-Reviews-NL-NL-D.avif": 95554,
	"./Features-Block-Reviews-PL-PL-D.avif": 78606,
	"./Features-Block-Reviews-PT-BR-D.avif": 25766,
	"./Features-Block-Reviews-PT-PT-D.avif": 80206,
	"./Features-Block-Reviews-SV-SE-D.avif": 12265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 614;